// import React, { useState, useEffect } from "react";
// import { db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";
// import css from "./foreignRights.module.css";

// const Banner = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const documentId = "uniqueForeignRight";

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const docRef = doc(db, "foreignRights", documentId);
//         const docSnap = await getDoc(docRef);

//         if (docSnap.exists()) {
//           setData(docSnap.data());
//         } else {
//           console.error("Document not found");
//         }
//       } catch (error) {
//         console.error("Error fetching banner data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading || !data) {
//     return <div>Loading banner...</div>;
//   }

//   return (
//     <div className={css.wrapBanner}>
//       <div className={css.wrapFirstTextIn}>
//         <p className={css.mainP}>{data.bannerTitle}</p>
//         <p className={css.descPBanner}>
//           {data.bannerText}
//           <br />
//           <span className={css.spanDescBanner}>
//             {data.location}
//             <br />
//             {data.year}
//             <br />
//             {data.focus}
//           </span>
//         </p>
//         {data.link ? (
//           <a
//             href={data.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className={css.buttonRight}
//           >
//             Rights Guide
//           </a>
//         ) : (
//           <div className={css.buttonRightDisabled}>
//             No Rights Guide Available
//           </div>
//         )}
//       </div>
//       {data.bannerImage && (
//         <img
//           src={data.bannerImage}
//           className={css.photoForForeight}
//           alt="Banner"
//         />
//       )}
//     </div>
//   );
// };

// export default Banner;

import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import css from "./foreignRights.module.css";

const Banner = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const documentId = "uniqueForeignRight";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "foreignRights", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.error("Document not found");
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading || !data) {
    return <div>Loading banner...</div>;
  }

  return (
    <div className={css.wrapBanner}>
      <div className={css.wrapFirstTextIn}>
        <p className={css.mainP}>{data.bannerTitle}</p>
        <p className={css.descPBanner}>
          {data.bannerText}
          <br />
          <span className={css.spanDescBanner}>
            {data.location}
            <br />
            {data.year}
            <br />
            {data.focus}
          </span>
        </p>
        {data.link ? (
          <a
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
            className={css.buttonRight}
          >
            Rights Guide
          </a>
        ) : (
          <div className={css.buttonRightDisabled}>
            No Rights Guide Available
          </div>
        )}
      </div>
      {data.bannerImage && (
        <img
          src={data.bannerImage}
          className={css.photoForForeight}
          alt="Banner"
        />
      )}
    </div>
  );
};

export default Banner;
